import axios from 'axios';

// Prefer an explicit API origin, but fall back to the current origin so the
// same production build can run behind multiple portal hostnames.
let baseURL = process.env.REACT_APP_API_BASE_URL;
if (!baseURL) {
  if (typeof window !== 'undefined' && window.location?.origin) {
    baseURL = window.location.origin;
  } else if (process.env.NODE_ENV === 'production') {
    throw new Error('REACT_APP_API_BASE_URL must be set or resolvable from window.location.origin in production.');
  } else {
    baseURL = 'http://localhost:5000';
  }
}

const api = axios.create({
  baseURL,
  withCredentials: true, // include cookies (Cognito HttpOnly tokens)
});

export default api;
